/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "566")
  

// 接口文档

  
    
export interface IAPI77002ReqInputsItem {
  
  /** 输入code */
  inputCode?: string;
  
  /** 输入内容 */
  inputValue?: string;
  
};
    
  
    
export interface IAPI77002ResInputUserObj {
  
  /** 头像 */
  headImg?: string;
  
  /** 昵称 */
  nickName?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 用户id */
  userId?: string;
  
};
    
  
    
export interface IAPI77002ResOutputUserObj {
  
  /** 头像 */
  headImg?: string;
  
  /** 昵称 */
  nickName?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 用户id */
  userId?: string;
  
};
    
  
    
export type IAPI77002ResExtDataObjDataObj = {};
    
  
    
export interface IAPI77002ResExtDataObj {
  
  /** 数据类型 */
  dataType?: string;
  
  /** 数据 ,Object */
  data?: IAPI77002ResExtDataObjDataObj;
  
};
    
  



export interface API77002Req {
  
  /** 应用code */
  appCode: string;
  /** sessionCode */
  sessionCode: string;
  /** 输入信息 */
  inputs: string;
  /** 应用code */
  appCode: string;
  /** sessionCode */
  sessionCode?: string;
  /** 输入信息 ,ChatInputRequest */
  inputs?: IAPI77002ReqInputsItem[];
  /** 用户输入 */
  message?: string;
};



export interface API77002Res {
  /** 主键  */
  id?: number;
  /** 应用实例编码  */
  appInstanceCode?: string;
  /** 会话编号  */
  sessionCode?: string;
  /** 输入用户信息 ,ChatUserResponse  */
  inputUser?: IAPI77002ResInputUserObj;
  /** 输出用户信息 ,ChatUserResponse  */
  outputUser?: IAPI77002ResOutputUserObj;
  /** 输入内容  */
  inputContent?: string;
  /** 输出内容  */
  outputContent?: string;
  /** 输入时间  */
  inputTime?: any;
  /** 输出时间  */
  outputTime?: any;
  /** 扩展信息 ,ExtDataResponse  */
  extData?: IAPI77002ResExtDataObj;
  
};


// 接口函数 77002 发送消息

export interface IUsePostAPI77002Return {
  /** 发送消息: 接口请求状态 */
  isAPI77002Loading: boolean;
  /** 发送消息: 接口请求返回数据 */
  dataAPI77002: API77002Res;
  /**  发送消息: 接口数据请求方法 */
  fetchAPI77002Data: (inputs: API77002Req, config?: YWRequestConfig) => Promise<API77002Res>;
  /** 发送消息: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77002 = ():IUsePostAPI77002Return => {
  let isMount = true;
  const [isAPI77002Loading, setIsAPI77002Loading] = useState(false);
  const [dataAPI77002, setDataAPI77002] = useState<API77002Res>({} as API77002Res);
  const requestUrl = `${basePath}/yoaichat-admin/chat/send`;

  const fetchAPI77002Data = async (inputs: API77002Req, config?: YWRequestConfig): Promise<API77002Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77002Req>) || {}) as API77002Req;
    
  
    if ( isMount ) {
      setIsAPI77002Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77002Res>(`${basePath}/yoaichat-admin/chat/send`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77002(res || {} as API77002Res);
        setIsAPI77002Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77002Loading(false);
      }
      return false as unknown as API77002Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77002Loading,
    dataAPI77002,
    fetchAPI77002Data,
    requestUrl,
  }
}

